export * from "./interpolate";
export * from "./interpolateColors";
export * from "./interpolateVector";
export * from "./interpolatePaths";
